var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"view-ribbon ribbon",class:`
	size-${_vm.size}
	type-${_vm.type}
	${_vm.animated ? 'animation-float' : ''}
`},[_c('h3',[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }